import React, { useRef, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import emailjs from 'emailjs-com';
import Swal from 'sweetalert2';

export const Contact = () => {
  const form = useRef();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Set loaded to true after a short delay to allow animations to occur
    const timeout = setTimeout(() => {
      setLoaded(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    // Check if any form field is empty
    const formFields = form.current.querySelectorAll('input, textarea');
    let isFormEmpty = false;
    formFields.forEach((field) => {
      if (!field.value.trim()) {
        isFormEmpty = true;
      }
    });

    // If form is empty, display error SweetAlert message and return
    if (isFormEmpty) {
      displayErrorAlert();
      return;
    }

    // Display success SweetAlert message
    displaySuccessAlert();

    // Proceed with sending email if form is not empty
    emailjs
      .sendForm('service_iw5ygjd', 'template_w0d5a9j', form.current, 'x7zELknyOmALu8yMw')
      .then(
        (result) => {
          console.log('Email successfully sent!', result.text);
          // Clear form fields
          form.current.reset();
        },
        (error) => {
          console.error('Email sending failed:', error.text);
        }
      );
  };

  const displaySuccessAlert = () => {
    // Display success SweetAlert message
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: 'success',
      title: 'Submitted successfully',
    });
  };

  const displayErrorAlert = () => {
    // Display error SweetAlert message
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: 'error',
      title: 'Please fill out the form!',
    });
  };

  const { page } = useParams();

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  }, [page]);

  return (
    <div className={`isolate bg-white px-6 py-6 sm:py-8 lg:px-8 ${loaded ? 'slide-in' : ''}`}>
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Contact Us</h2>
        <p className="mt-2 text-lg leading-8 text-gray-600">
        We welcome feedback. If you have any initial thoughts and opinions on the project, we'd love to hear them below.
        </p>

        <div className="py-2 flex justify-center items-center space-x-6 lg:space-x-12 mt-6 lg:mt-0">
          {/* Twitter link */}
          <a href="https://x.com/amani_balozi?t=MpJmNbAVgPkfc12hy0gTXA&s=08" target="_blank" rel="noopener noreferrer" className="mx-2 md:mx-6 transition-transform transform hover:scale-110" style={{ textDecoration: 'none' }}>
            <img width="32" height="32" src="https://img.icons8.com/ios-filled/50/twitterx--v1.png" alt="twitterx--v1" />
          </a>
          {/* Facebook link */}
          <a href="https://www.facebook.com/share/ViGBjUs7Qxdf1zoE/?mibextid=qi2Omg" target="_blank" rel="noopener noreferrer" className="mx-2 md:mx-6 py-0.5 transition-transform transform hover:scale-110" style={{ textDecoration: 'none' }}>
            <img width="27" height="27" src="https://img.icons8.com/android/24/facebook.png" alt="facebook" />
          </a>
          {/* Instagram link */}
          <a href="https://www.instagram.com/balozi_wa_amani_initiative?igsh=bnN0eTBmeTJzM3l5" target="_blank" rel="noopener noreferrer" className="mx-2 md:mx-6 py-0.5 transition-transform transform hover:scale-110" style={{ textDecoration: 'none' }}>
            <img width="28" height="28" src="https://img.icons8.com/ios/50/instagram-new--v1.png" alt="instagram-new--v1" />
          </a>
        </div>

        <h1 className="py-1 font-bold mt-2 text-lg leading-8 text-black">
          Phone: <span className="text-red-600">+254 720009414 / +254 733278353 </span>
        </h1>
        <h1 className="font-bold mt-2 text-lg leading-8 text-black ">
          Email:  <a href="mailto:baloziwaamaniinitiative@gmail.com" className="hover:text-black text-red-600">baloziwaamaniinitiative@gmail.com</a>
        </h1>

      </div>
      <form className="mx-auto mt-12 max-w-xl sm:mt-12" onSubmit={sendEmail} ref={form}>
        <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
          <div className="sm:col-span-2">
            <label htmlFor="name" className="block text-lg font-bold leading-6 text-gray-900">
              Name:
            </label>
            <div className="mt-2.5">
              <input
                type="text"
                name="from_name"
                id="name"
                autoComplete="name"
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50 mx-auto"
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="email" className="block text-lg font-bold leading-6 text-gray-900">
              Email:
            </label>
            <div className="mt-2.5">
              <input
                type="email"
                name="from_email"
                id="email"
                autoComplete="email"
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50 mx-auto"
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="phone-number" className="block text-lg font-bold leading-6 text-gray-900">
              Phone number:
            </label>
            <div className="relative mt-2.5">
              <input
                type="tel"
                name="from_number"
                id="phone-number"
                autoComplete="tel"
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50 mx-auto"
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="message" className="block text-lg font-bold leading-6 text-gray-900">
              Message:
            </label>
            <div className="mt-2.5">
              <textarea
                name="message"
                id="message"
                rows={4}
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50 mx-auto"
                defaultValue={''}
              />
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center mt-10">
          <button
            type="submit"
            className="block w-64 rounded-md bg-red-600 px-1 py-2.5 text-center text-base font-bold text-white shadow-sm hover:bg-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            SUBMIT
          </button>
        </div>
      </form>
    </div>
  );
};
